import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { QuotationFormValues } from "../../../types";
import { QuotationFieldConfig } from "../types";
import { useStyles } from "./styles";

const formatCurrency = (value: string) => {
  if (!value || value === "0") {
    return "₪0";
  }

  if (value.startsWith("₪")) {
    return value;
  }

  return `₪${value}`;
};

type Props = {
  config: QuotationFieldConfig;
  value: string;
};

const QuotationField = ({ config, value }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const displayValue = config.currency ? formatCurrency(value) : value;

  return (
    <Box className={styles.fieldMetric}>
      <Typography className={styles.fieldLabel}>{t(config.labelKey)}</Typography>
      <Typography className={styles.fieldValue}>{displayValue}</Typography>
    </Box>
  );
};

export const renderQuotationFields = (
  fields: QuotationFieldConfig[],
  formValues: QuotationFormValues
) =>
  fields.map((config) => (
    <QuotationField
      key={String(config.field)}
      config={config}
      value={formValues[config.field] as string}
    />
  ));

export default QuotationField;
